import dollars from '../../../dollar-format';
import {addCommasToNumber} from '../../../utils';

export class StatsData {
    activeCount;
    activePrice;
    activeSqft;
    activeAvgCapRate;
    activeAvgTimeOnMarket;
    negUcCount;
    negUcPrice;
    negUcSqft;
    negUcAvgCapRate;
    closedYtdCount;
    closedYtdPrice;
    closedYtdAvgCapRate;
    listClosedPrice;
    listClosedTime;
    closedSinceCount;
    closedSincePrice;
    closedSinceSqft;
    closedSinceAvgCapRate;
    closedIsCount;
    closedIsPrice;
    closedIsSqft;
    closedIsAvgCapRate;

    activeStnlCount;
    activeMtCount;
    activeMfCount;
    activeOtherCount;
    closedCount;
    closedStnlCount;
    closedMtCount;
    closedMfCount;
    closedOtherCount;

    constructor({dataByStatus, dataByType}) {
        this.activeCount = dataByStatus && dataByStatus.ACTIVE_PROPERTIES ? dataByStatus.ACTIVE_PROPERTIES : 0;
        this.activePrice = dataByStatus && dataByStatus.ACTIVE_PRICE ? dollars(dataByStatus.ACTIVE_PRICE) : '$0';
        this.activeSqft = dataByStatus && dataByStatus.ACTIVE_SQFT ? addCommasToNumber(dataByStatus.ACTIVE_SQFT) : 0;
        this.activeAvgCapRate = dataByStatus && dataByStatus.ACTIVE_CAP_RATE && dataByStatus.ACTIVE_PROPERTIES_CR ? `${(dataByStatus.ACTIVE_CAP_RATE / dataByStatus.ACTIVE_PROPERTIES_CR).toFixed(2)}%` : '0%';
        this.activeAvgTimeOnMarket = dataByStatus && dataByStatus.TIME_ON_MARKET && dataByStatus.TIME_ON_MARKET !== '0' && dataByStatus.PROPERTIES_TM ? `${parseInt(dataByStatus.TIME_ON_MARKET / dataByStatus.PROPERTIES_TM)} days` : '0 days';

        this.negUcCount = dataByStatus && dataByStatus.NEGOTIATION_PROPERTIES ? parseInt(dataByStatus.NEGOTIATION_PROPERTIES) : 0;
        this.negUcCount = dataByStatus && dataByStatus.UNDER_CONTRACT_PROPERTIES ? this.negUcCount + parseInt(dataByStatus.UNDER_CONTRACT_PROPERTIES) : this.negUcCount;
        this.negUcPrice = dataByStatus && dataByStatus.NEGOTIATION_PRICE ? parseInt(dataByStatus.NEGOTIATION_PRICE) : 0;
        this.negUcPrice = dataByStatus && dataByStatus.UNDER_CONTRACT_PRICE ? dollars(this.negUcPrice + parseInt(dataByStatus.UNDER_CONTRACT_PRICE)) : dollars(this.negUcPrice);
        this.negUcSqft = dataByStatus && dataByStatus.NEGOTIATION_SQFT ? parseInt(dataByStatus.NEGOTIATION_SQFT) : 0;
        this.negUcSqft = dataByStatus && dataByStatus.UNDER_CONTRACT_SQFT ? addCommasToNumber(this.negUcSqft + parseInt(dataByStatus.UNDER_CONTRACT_SQFT)) : addCommasToNumber(this.negUcSqft);
        this.negUcAvgCapRate = dataByStatus && dataByStatus.NEGOTIATION_CAP_RATE ? parseFloat(dataByStatus.NEGOTIATION_CAP_RATE) : 0;
        this.negUcAvgCapRate = dataByStatus && dataByStatus.UNDER_CONTRACT_CAP_RATE ? this.negUcAvgCapRate + parseFloat(dataByStatus.UNDER_CONTRACT_CAP_RATE) : this.negUcAvgCapRate;
        this.negUcAvgCapRate = dataByStatus && (dataByStatus.NEGOTIATION_PROPERTIES_CR || dataByStatus.dataByStatus.UNDER_CONTRACT_PROPERTIES_CR) ? `${(this.negUcAvgCapRate / (parseInt(dataByStatus.NEGOTIATION_PROPERTIES_CR) + parseInt(dataByStatus.UNDER_CONTRACT_PROPERTIES_CR))).toFixed(2)}%` : '0%';

        const key = dataByStatus && dataByStatus.CLOSED_YTD_PROPERTIES && parseInt(dataByStatus.CLOSED_YTD_PROPERTIES) < 7 ? 'PRIOR_' : '';
        this.closedYtdCount = dataByStatus && dataByStatus[`CLOSED_${key}YTD_PROPERTIES`] ? dataByStatus[`CLOSED_${key}YTD_PROPERTIES`] : 0;
        this.closedYtdPrice = dataByStatus && dataByStatus[`CLOSED_${key}YTD_PRICE`] ? dollars(dataByStatus[`CLOSED_${key}YTD_PRICE`]) : '$0';
        this.closedYtdAvgCapRate = dataByStatus && parseFloat(dataByStatus[`CLOSED_${key}YTD_CAP_RATE`]) && parseInt(dataByStatus[`CLOSED_${key}YTD_PROPERTIES_CR`]) ? `${(dataByStatus[`CLOSED_${key}YTD_CAP_RATE`] / dataByStatus[`CLOSED_${key}YTD_PROPERTIES_CR`]).toFixed(2)}%` : '0%';
        this.listClosedPrice = dataByStatus && parseInt(dataByStatus[`CLOSED_${key}YTD_LIST_PRICE`]) ? `${(100 - Math.abs(((dataByStatus[`CLOSED_${key}YTD_LIST_PRICE`] - dataByStatus[`CLOSED_${key}YTD_PRICE`]) / dataByStatus[`CLOSED_${key}YTD_LIST_PRICE`] * 100))).toFixed(2)}%` : '0%';
        this.listClosedTime = dataByStatus && parseFloat(dataByStatus[`${key}LIST_CLOSED_TIME`]) && parseInt(dataByStatus[`${key}PROPERTIES_LCT`]) ? `${Math.abs(Math.round(dataByStatus[`${key}LIST_CLOSED_TIME`] / 30 / dataByStatus[`${key}PROPERTIES_LCT`] * 2) / 2)} months` : '0 months';

        this.closedSinceCount = dataByStatus && dataByStatus.CLOSED_PROPERTIES ? dataByStatus.CLOSED_PROPERTIES : 0;
        this.closedSincePrice = dataByStatus && dataByStatus.CLOSED_PRICE ? dollars(dataByStatus.CLOSED_PRICE) : '$0';
        this.closedSinceSqft = dataByStatus && dataByStatus.CLOSED_SQFT ? addCommasToNumber(dataByStatus.CLOSED_SQFT) : 0;
        this.closedSinceAvgCapRate = dataByStatus && dataByStatus.CLOSED_CAP_RATE && dataByStatus.CLOSED_PROPERTIES_CR ? `${(dataByStatus.CLOSED_CAP_RATE / dataByStatus.CLOSED_PROPERTIES_CR).toFixed(2)}%` : '0%';

        // Investment Sales
        this.closedIsCount = dataByStatus && dataByStatus.CLOSED_IS_PROPERTIES ? dataByStatus.CLOSED_IS_PROPERTIES : 0;
        this.closedIsPrice = dataByStatus && dataByStatus.CLOSED_IS_PRICE ? dollars(dataByStatus.CLOSED_IS_PRICE) : '$0';
        this.closedIsSqft = dataByStatus && dataByStatus.CLOSED_IS_SQFT ? addCommasToNumber(dataByStatus.CLOSED_IS_SQFT) : 0;
        this.closedIsAvgCapRate = dataByStatus && dataByStatus.CLOSED_IS_CAP_RATE && dataByStatus.CLOSED_IS_PROPERTIES_CR ? `${(dataByStatus.CLOSED_IS_CAP_RATE / dataByStatus.CLOSED_IS_PROPERTIES_CR).toFixed(2)}%` : '0%';

        this.activeStnlCount = dataByType && dataByType.ACTIVE_STNL_COUNT ? parseInt(dataByType.ACTIVE_STNL_COUNT) : 0;
        this.activeMtCount = dataByType && dataByType.ACTIVE_MT_COUNT ? parseInt(dataByType.ACTIVE_MT_COUNT) : 0;
        this.activeMfCount = dataByType && dataByType.ACTIVE_MF_COUNT ? parseInt(dataByType.ACTIVE_MF_COUNT) : 0;
        this.activeOtherCount = dataByType && dataByType.ACTIVE_OTHER_COUNT ? parseInt(dataByType.ACTIVE_OTHER_COUNT) : 0;        
        this.closedCount = dataByType && dataByType.CLOSED_COUNT ? parseInt(dataByType.CLOSED_COUNT) : 0;
        this.closedStnlCount = dataByType && dataByType.CLOSED_STNL_COUNT ? parseInt(dataByType.CLOSED_STNL_COUNT) : 0;
        this.closedMtCount = dataByType && dataByType.CLOSED_MT_COUNT ? parseInt(dataByType.CLOSED_MT_COUNT) : 0;
        this.closedMfCount = dataByType && dataByType.CLOSED_MF_COUNT ? parseInt(dataByType.CLOSED_MF_COUNT) : 0;
        this.closedOtherCount = dataByType && dataByType.CLOSED_OTHER_COUNT ? parseInt(dataByType.CLOSED_OTHER_COUNT) : 0;
    }
}